import { LEVEL_STYLES, LEVEL_ORDER, FACTOR_STATUS_STYLES } from "@/components/hfacs/hfacsLevels";

export default function MeetingFactorsView({ factors }) {
  const retained = factors.filter((f) => f.STATUT_ANALYSE === "Retenu");
  if (retained.length === 0) {
    return <p className="text-lg text-muted-foreground text-center py-20">Aucun facteur retenu pour l'instant.</p>;
  }
  return (
    <div className="max-w-5xl mx-auto space-y-10" data-testid="meeting-factors-view">
      {LEVEL_ORDER.map((level) => {
        const items = retained.filter((f) => f.NIVEAU === level);
        if (items.length === 0) return null;
        const style = LEVEL_STYLES[level];
        return (
          <section key={level}>
            <h3 className={`inline-flex font-mono text-sm uppercase px-3 py-1.5 rounded-sm border mb-4 ${style.badge}`}>{level}</h3>
            <div className="grid sm:grid-cols-2 gap-4">
              {items.map((f) => (
                <div key={f.ID} data-testid={`meeting-factor-card-${f.ID_FACTEUR}`} className={`bg-card border ${style.border} rounded-md p-4`}>
                  <p className="text-base font-medium leading-snug">{f.FACTEUR}</p>
                  <span className={`inline-block mt-2 font-mono text-xs uppercase px-2 py-0.5 rounded-sm border ${FACTOR_STATUS_STYLES[f.STATUT_ANALYSE] || ""}`}>
                    {f.STATUT_ANALYSE}
                  </span>
                </div>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
